function getCss(value, valid) {
    if (value == null || value == "") {
        return "none";
    } else if (valid) {
        return "success";
    } else {
        return "fail";
    }
}

(function (common, $, undefined) {

	// public configuration variable
	common.config = {};

	// bind events and such to the DOM
	// private function
	function bindEvents() {
		$(window).on('load', function () {

			common.navMobile();
			common.profileNav();
			common.jumpToTop();
			common.localization();
			//common.equalheight('.eh');

			common.displayAlert();
		});

		$(window).on('resize', function () {
			if (common.checkWidth() != 'mobile') {
				//$('#main-nav').collapse('hide');
				$('#main-nav').removeClass('open');
			}
		});

		$('.js-alert-close').on('click', function () {
			common.closeAlert();
		});
	}

	common.getCookie = function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	// Display Alert 
	common.displayAlert = function () {
		var alertID = $('.js-alert').data('alert');
		var alertShown = common.getCookie('alertShown');
		var $alert = $('.js-alert');

		if ($alert.length) {
			if (alertShown != alertID) {
				$alert.fadeIn('fast', function () {
					$(this).removeClass('hidden');
				});
			}
		}

	}

	// Close Alert 
	common.closeAlert = function () {
		var alertID = $('.js-alert').data('alert');
		$('.js-alert').fadeOut('fast', function () {
			$(this).addClass('hidden');
		});

		document.cookie = 'alertShown =' + alertID;
	}

	// Check Width
	common.checkWidth = function () {
		var desktopBreakpoint = 970;
		var tabletBreakpoint = 750;

		var width = $(document).width();

		if (width >= desktopBreakpoint) {
			return 'desktop';
		} else if (width >= tabletBreakpoint) {
			return 'tablet';
		}
		return 'mobile';
	}

	// Equal Height Elements
	common.equalheight = function (container) {
		var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;

		$(container)
            .each(function () {
            	$el = $(this);
            	$($el).height('auto');
            	var topPostion = $el.position().top;
            	var currentDiv;

            	if (currentRowStart !== topPostion) {
            		for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            			rowDivs[currentDiv].height(currentTallest);
            		}
            		rowDivs.length = 0; // empty the array
            		currentRowStart = topPostion;
            		currentTallest = $el.height();
            		rowDivs.push($el);
            	} else {
            		rowDivs.push($el);
            		currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
            	}
            	for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            		rowDivs[currentDiv].height(currentTallest);
            	}
            });
	}

	common.navMobile = function () {
		$('.navbar-toggle').on('click', function () {
			$(this).toggleClass('open');
			$('.header-profile').removeClass('open');
			$('.profile-dropdown').removeClass('in');
		});
	}

	common.jumpToTop = function () {
		var $backToTop = $('.back-to-top');

		$(window).on("scroll", function () {
			if ($(this).scrollTop() >= 50) {
				$backToTop.fadeIn(200);
			} else {
				$backToTop.fadeOut(200);
			}
		});

		$backToTop.on('click', function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
		});
	}

	common.profileNav = function () {
		$('.header-profile').on('click', function () {
			$(this).toggleClass('open');

			$('.navbar-toggle').removeClass('open');
			$('#main-nav').removeClass('in');
		});
	}

	common.localization = function () {
		$('#localization-list input[name="language"]').on('change', function () {
			var code = $(this).val();

			window.location.href = window.location.pathname + "?culturecode=" + code;
		});
	}

	$('.js-pass-value-in-href').on("click", function (e) {
		common.bindValueToHref(e);
	});

	common.bindValueToHref = function (e) {
		var href = e.target.getAttribute("href");
		var key = e.target.getAttribute("data-key");
		var selector = e.target.getAttribute("data-value");
		var value = $(selector).val();
		var separator = (href.indexOf("?") === -1) ? "?" : "&";
		var uri = href + separator + key + "=" + value;

		e.preventDefault();
		window.location.href = uri;

	}

	// initialize object 
	// this is a public function
	common.init = function () {
		var RVS = window.RVS || {};
		RVS.Data = RVS.Data || {};

		bindEvents();
	}
})(window.common = window.common || {}, jQuery);

// self initialize once the DOM is loaded
(function ($) {
	common.init();
}(jQuery));



// WEBPACK FOOTER //
// ./Content/js/app/common.js